'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _DeliveryTypeItem = require('./DeliveryTypeItem');

var _DeliveryTypeItem2 = _interopRequireDefault(_DeliveryTypeItem);

var _PaymentTypeItem = require('./PaymentTypeItem');

var _PaymentTypeItem2 = _interopRequireDefault(_PaymentTypeItem);

var _SummaryBox = require('./SummaryBox');

var _SummaryBox2 = _interopRequireDefault(_SummaryBox);

var _FixStepButton = require('../FixStepButton');

var _FixStepButton2 = _interopRequireDefault(_FixStepButton);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _sticky = require('linksoft-albatros/src/components/sticky');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _common = require('../../../../common');

var _common2 = _interopRequireDefault(_common);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    var zasilkovnaKey = _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaKey');
    var zasilkovnaCzKey = _common2.default.findDeliveryRefSafe(state.cart, 'zasilkovnaCzKey');
    var pplParcelShopKey = _common2.default.findDeliveryRefSafe(state.cart, 'pplParcelShopKey');
    var balikovnaKey = _common2.default.findDeliveryRefSafe(state.cart, 'balikovnaKey');

    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    var allowedDeliveryTypes = getAllowedDeliveryTypes(state.cart.deliveryTypes, state.cart.items);
    var deliveryType = getDeliveryType(allowedDeliveryTypes, options.deliveryTypeId);
    var isPickupPlaceCustom = deliveryType ? [zasilkovnaKey, zasilkovnaCzKey, pplParcelShopKey, balikovnaKey].indexOf(deliveryType.reference) >= 0 : false;
    var pickupPlaceRequired = deliveryType && (deliveryType.pickupPlaces.length > 0 || isPickupPlaceCustom);

    var paymentType = getPaymentType(state.cart.paymentTypes, options.paymentTypeId);
    var financialInstitutionRequired = paymentType && paymentType.financialInstitutions.length > 0;
    var accountNumberAndPinRequired = paymentType && paymentType.userInterface === 2;
    return {
        zasilkovnaKey: zasilkovnaKey,
        zasilkovnaCzKey: zasilkovnaCzKey,
        pplParcelShopKey: pplParcelShopKey,
        balikovnaKey: balikovnaKey,
        deliveryTypeId: deliveryType === null ? null : options.deliveryTypeId,
        paymentTypeId: options.paymentTypeId,
        phoneCountryCode: options.phoneCountryCode,
        pickupPlaceId: options.pickupPlaceId,
        pickupPlaceName: state.cart.pickupPlaceName || (state.cart.pickupPlace || {}).name,
        financialInstitutionId: options.financialInstitutionId,
        deliveryTypes: allowedDeliveryTypes,
        paymentTypes: state.cart.paymentTypes,
        pickupPlaceRequired: pickupPlaceRequired || false,
        accountNumberAndPinRequired: accountNumberAndPinRequired || false,
        financialInstitutionRequired: financialInstitutionRequired || false,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changedOptions).length)
    };
}

function getAllowedDeliveryTypes(deliveryTypes, items) {
    var totalCount = items.reduce(function (a, b) {
        return a + (b.amount || 0);
    }, 0);
    var result = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(deliveryTypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var d = _step.value;

            if (!d.collection || d.collection.length === 0) continue;

            var maxOrderCount = d.collection[0].maxOrderCount;

            if (maxOrderCount == null || totalCount <= maxOrderCount) {
                result.push(d);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}

function getPaymentType(paymentTypes, paymentTypeId) {
    for (var i = 0; i < paymentTypes.length; i++) {
        if (paymentTypes[i].id === paymentTypeId) return paymentTypes[i];
    }
    return null;
}

function getDeliveryType(deliveryTypes, deliveryTypeId) {
    for (var i = 0; i < deliveryTypes.length; i++) {
        var d = deliveryTypes[i];
        var deliveryType = d.collection.find(function (x) {
            return x.id === deliveryTypeId;
        });
        if (deliveryType) return deliveryType;
    }
    return null;
}

var mapDispatchToProps = {
    setStep: _actions2.default.setStep,
    saveOptions: _actions2.default.saveOptions,
    savePaymentDeliveryFreeProducts: _actions2.default.savePaymentDeliveryFreeProducts,
    setProcessing: _actions2.default.setProcessing
};

var CartDetailStep2 = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(CartDetailStep2, _CartDetailStepBase);

    function CartDetailStep2(props) {
        (0, _classCallCheck3.default)(this, CartDetailStep2);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetailStep2.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep2)).call(this, props, 2));

        _this.changeState = function (field, value) {
            var newState = (0, _extends3.default)({}, _this.state);
            newState[field] = value;
            _this.setState(newState);
        };

        _this.state = {
            pristine: true, accountNumber: '', accountPin: ''
        };
        return _this;
    }

    (0, _createClass3.default)(CartDetailStep2, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.cart.step === prevProps.cart.step) return;

            var newState = {
                pristine: true, accountNumber: '', accountPin: ''
            };
            this.setState(newState);
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            if (this.canContinue()) {
                this.props.setProcessing(true);
                this.props.savePaymentDeliveryFreeProducts(this.props.cart);
                (0, _get3.default)(CartDetailStep2.prototype.__proto__ || (0, _getPrototypeOf2.default)(CartDetailStep2.prototype), 'nextStep', this).call(this);
            }
            if (this.props.accountNumberAndPinRequired) {
                this.props.saveOptions({
                    accountNumber: this.state.accountNumber, accountPin: this.state.accountPin
                });
            }
            this.setState({ pristine: false });
        }
    }, {
        key: 'canContinue',
        value: function canContinue() {
            var _props = this.props,
                deliveryTypeId = _props.deliveryTypeId,
                paymentTypeId = _props.paymentTypeId,
                pickupPlaceId = _props.pickupPlaceId,
                pickupPlaceRequired = _props.pickupPlaceRequired,
                financialInstitutionRequired = _props.financialInstitutionRequired,
                accountNumberAndPinRequired = _props.accountNumberAndPinRequired,
                financialInstitutionId = _props.financialInstitutionId,
                processing = _props.processing;

            return !processing && typeof deliveryTypeId === 'number' && typeof paymentTypeId === 'number' && (!pickupPlaceRequired || typeof pickupPlaceId === 'number') && (!financialInstitutionRequired || typeof financialInstitutionId === 'number') && (!accountNumberAndPinRequired || this.state.accountNumber !== '' && this.state.accountPin !== '');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.isActive() && !this.isPrevious()) return null;
            if (this.isLoading()) {
                return _react2.default.createElement('div', { className: this.stepClass() });
            }
            var _props2 = this.props,
                deliveryTypes = _props2.deliveryTypes,
                paymentTypes = _props2.paymentTypes,
                deliveryTypeId = _props2.deliveryTypeId,
                paymentTypeId = _props2.paymentTypeId,
                pickupPlaceId = _props2.pickupPlaceId,
                pickupPlaceName = _props2.pickupPlaceName,
                pickupPlaceRequired = _props2.pickupPlaceRequired;
            var pristine = this.state.pristine;


            if (this.isActive()) {
                var submitBtnClass = 'btn btn--xl btn--green';
                if (!this.canContinue()) {
                    submitBtnClass += ' btn--inactive';
                }

                var showDeliveryWarning = !pristine && (!deliveryTypeId || pickupPlaceRequired && !pickupPlaceId);
                var deliveryInfotext = '';
                if (Resx.App.CartDeliveryCountryInformation.trim() !== '') {
                    deliveryInfotext = _react2.default.createElement(
                        'div',
                        { className: 'warning warning--sm' },
                        _react2.default.createElement(
                            'span',
                            { className: 'warning__message' },
                            Resx.App.CartDeliveryCountryInformation
                        )
                    );
                }

                var payImgBasePath = '/Content/images/payment/';
                var additionalPaymentLogos = _utils2.default.skEnvironment() ? [{ url: payImgBasePath + 'viamo.png', alt: 'Viamo' }, { url: payImgBasePath + 'googlepay.png', alt: 'Google Pay' }, { url: payImgBasePath + 'applepay.png', alt: 'Apple Pay' }] : [];

                return _react2.default.createElement(
                    'div',
                    { className: this.stepClass() },
                    _react2.default.createElement(
                        'div',
                        { className: 'step__inner' },
                        _react2.default.createElement(
                            _sticky.StickyContainer,
                            { className: 'c-step-2__left' },
                            _react2.default.createElement(
                                _sticky.Sticky,
                                { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
                                function (_ref) {
                                    var style = _ref.style;
                                    return _react2.default.createElement(
                                        'div',
                                        {
                                            style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? (0, _extends3.default)({}, style, { paddingTop: 30 }) : {} },
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(
                                                'h3',
                                                { className: 'cart__section-title' },
                                                Resx.App.ChooseTrasnportType,
                                                ':\xA0',
                                                !!showDeliveryWarning && _react2.default.createElement('i', { className: 'icon--caution' }),
                                                !!showDeliveryWarning && _react2.default.createElement(
                                                    'div',
                                                    { className: 'additional-info' },
                                                    Resx.App.DeliveryTypeIsMandatory
                                                )
                                            ),
                                            deliveryInfotext,
                                            _react2.default.createElement(
                                                'div',
                                                { id: 'deliveryList' },
                                                deliveryTypes.map(function (i) {
                                                    return _react2.default.createElement(_DeliveryTypeItem2.default, (0, _extends3.default)({
                                                        key: i.id
                                                    }, i));
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'h3',
                                                { className: 'cart__section-title space-t-40' },
                                                Resx.App.ChoosePaymentType,
                                                ':\xA0',
                                                !pristine && !paymentTypeId && _react2.default.createElement('i', { className: 'icon--caution' }),
                                                !pristine && !paymentTypeId && _react2.default.createElement(
                                                    'div',
                                                    { className: 'additional-info' },
                                                    Resx.App.PaymentTypeIsMandatory
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { id: 'paymentList' },
                                                paymentTypes.map(function (i) {
                                                    var state = (0, _extends3.default)({}, i, _this2.state);
                                                    return _react2.default.createElement(_PaymentTypeItem2.default, (0, _extends3.default)({ key: i.id }, state, {
                                                        changeState: _this2.changeState }));
                                                })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'warning warning--sm' },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'warning__message' },
                                                    Resx.App.CartInvoicePaymentPossibility,
                                                    _react2.default.createElement(_Tooltip2.default, { className: 'test',
                                                        text: Resx.App.CartInvoicePaymentPossibilityDescription })
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'cart__payment' },
                                                _react2.default.createElement('img', { className: 'payment__card', src: '/Content/images/payment/visa.svg',
                                                    alt: 'Visa' }),
                                                _react2.default.createElement('img', { className: 'payment__card', src: '/Content/images/payment/master-card.svg',
                                                    alt: 'Master Card' }),
                                                additionalPaymentLogos.map(_this2.additionalPaymentIcon)
                                            ),
                                            _react2.default.createElement('hr', null),
                                            _react2.default.createElement('div', { className: 'payment__bank' })
                                        )
                                    );
                                }
                            )
                        ),
                        _react2.default.createElement(
                            _sticky.StickyContainer,
                            { className: 'cart__aside' },
                            _react2.default.createElement(
                                _sticky.Sticky,
                                {
                                    topOffset: 30,
                                    disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('xs') },
                                function (_ref2) {
                                    var style = _ref2.style;
                                    return _react2.default.createElement(
                                        'div',
                                        { style: !(0, _linksoftAlbatros.isMaxWidth)('xs') ? style : {} },
                                        _react2.default.createElement(_SummaryBox2.default, { cart: _this2.props.cart }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'cart__submit' },
                                            _react2.default.createElement(
                                                'button',
                                                {
                                                    id: 'cartStep2Submit',
                                                    className: submitBtnClass,
                                                    onClick: function onClick() {
                                                        return _this2.nextStep();
                                                    } },
                                                Resx.App.ContactInformation,
                                                _react2.default.createElement('i', { className: 'icon--arrow-right' })
                                            )
                                        )
                                    );
                                }
                            )
                        )
                    )
                );
            } else if (this.isPrevious()) {
                var _props3 = this.props,
                    _deliveryTypeId = _props3.deliveryTypeId,
                    _paymentTypeId = _props3.paymentTypeId,
                    _pickupPlaceId = _props3.pickupPlaceId;

                var deliveryType = deliveryTypes.map(function (x) {
                    return x.collection.find(function (i) {
                        return i.id === _deliveryTypeId;
                    });
                }).find(function (x) {
                    return x;
                });
                var paymentType = paymentTypes.find(function (x) {
                    return x.id === _paymentTypeId;
                });
                var deliveryTypeName = deliveryType && deliveryType.name;
                var paymentTypeName = paymentType && paymentType.name;
                return _react2.default.createElement(
                    _sticky.StickyContainer,
                    { className: this.stepClass() },
                    _react2.default.createElement(
                        _sticky.Sticky,
                        { disableCompensation: !!(0, _linksoftAlbatros.isMaxWidth)('sm') },
                        function (_ref3) {
                            var style = _ref3.style;
                            return _react2.default.createElement(
                                'div',
                                { style: !(0, _linksoftAlbatros.isMaxWidth)('sm') ? style : {} },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'selectedDeliveryAndPaymentType' },
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'cart__section-title' },
                                        Resx.App.SelectedDeliveryType
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-right' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'green h3 text-uppercase m-0' },
                                            deliveryTypeName
                                        ),
                                        _react2.default.createElement('br', null),
                                        _react2.default.createElement(
                                            'small',
                                            null,
                                            pickupPlaceName
                                        )
                                    ),
                                    _react2.default.createElement('hr', null),
                                    _react2.default.createElement(
                                        'h3',
                                        { className: 'cart__section-title' },
                                        Resx.App.PaymentTerms
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-right' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'green h3 text-uppercase m-0' },
                                            paymentTypeName
                                        )
                                    ),
                                    _react2.default.createElement('hr', null)
                                ),
                                _react2.default.createElement(_SummaryBox2.default, null),
                                _react2.default.createElement(_FixStepButton2.default, {
                                    text: Resx.App.FixTransportationAndPayment,
                                    onClick: function onClick() {
                                        return _this2.goToStep();
                                    }
                                })
                            );
                        }
                    )
                );
            }
            return null;
        }
    }, {
        key: 'additionalPaymentIcon',
        value: function additionalPaymentIcon(paymentEntry) {
            return _react2.default.createElement('img', { className: 'payment__card framed', src: paymentEntry.url, alt: paymentEntry.alt,
                key: 'payment_' + paymentEntry.alt });
        }
    }]);
    return CartDetailStep2;
}(_StepBase2.default), _class2.propTypes = {
    zasilkovnaKey: _propTypes2.default.string,
    zasilkovnaCzKey: _propTypes2.default.string,
    pplParcelShopKey: _propTypes2.default.string,
    balikovnaKey: _propTypes2.default.string,
    cart: _propTypes2.default.object.isRequired,
    deliveryTypeId: _propTypes2.default.number,
    paymentTypeId: _propTypes2.default.number,
    pickupPlaceId: _propTypes2.default.number,
    deliveryTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    paymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    pickupPlaceRequired: _propTypes2.default.bool.isRequired,
    processing: _propTypes2.default.bool,
    financialInstitutionRequired: _propTypes2.default.bool.isRequired,
    accountNumberAndPinRequired: _propTypes2.default.bool.isRequired
}, _temp)) || _class);
exports.default = CartDetailStep2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step2/Step2.js
// module id = 1026
// module chunks = 0